import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useEffect } from 'react';
import { Paper, Typography, Button, TableContainer, Table, TableBody, TextField, TableHead, TableRow, TableCell, IconButton, Grid } from '@mui/material';
import { TableLoader, Icon, InputWithIcon, getBank, toast } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import moment from 'moment';
import ChangePaymentMethodModalV2 from 'src/components/settings/ChangePaymentMethodModalV2';
import SubscriptionSummary from './SubscriptionsSummary';
import NoDataPlaceholder from 'src/components/shared/NoDataPlaceholder';
import { useStore } from 'src/stores';
import { useFormik } from 'formik';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { couponInitialValue, couponSchema } from 'src/utils/formValidation/Payment';
import useStyles from './styles';
export const SubscriptionsTab = observer(() => {
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchKey = _useState4[0],
    setSearchKey = _useState4[1];
  const _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    companyProperties = _useState6[0],
    setCompanyProperties = _useState6[1];
  const getValue = (param, sign) => {
    switch (sign) {
      case 'percent':
        return "%".concat(param);
      case 'dollar':
        return "$".concat(Number(param).toFixed(2));
      default:
        return param;
    }
  };
  const renderCell = (param, sign) => {
    const isNull = !param || param === null;
    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(classes.cellContent, " ").concat(isNull ? classes.noData : '', " cellContent")
    }, isNull ? 'N/A' : getValue(param, sign));
  };
  const renderPaymentCell = (param, sign) => {
    const isNull = !param || param === null;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.cellContent, " ").concat(isNull ? classes.noData : '', " cellContent")
    }, isNull ? 'N/A' : getValue(param.amount, sign)), !isNull ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.cellContentExtra)
    }, "on ".concat(moment(param.paymentDate).format('MM/DD/YY'))) : null);
  };
  const getFilteredData = () => companyProperties.filter(cp => {
    const searchPhrase = new RegExp(searchKey, 'gi');
    return searchKey.length > 0 ? (cp.assignedProperties || []).some(p => " ".concat(p.propertyAddress).search(searchPhrase) > 0) // search by property address for now
    : true;
  });
  const fetchData = async () => {
    setIsLoading(true);

    // const getAutopayMethod = async () => {
    //   const resp = await store.payment.getAutopayMethodAsync.run();
    //   return resp;
    // };

    const getPaymentMethods = async () => {
      const resp = await store.payment.getPaymentMethodsV2Async.run({
        applyToHomeDashboard: false
      });
      return resp;
    };
    const getCompanyProperties = async () => {
      const resp = await store.company.getCompanyPropertiesAsync.run();
      return resp;
    };
    const getCompanyUnits = async () => {
      const companyId = localStorage.getItem(USER_SETTINGS_KEYS.company) || '';
      const resp = await store.company.getCompanyUnitsAsync.run({
        companyId
      });
      return resp;
    };

    // const getCoupons = async () => {
    //   const resp = await store.payment.getCouponsAsync.run();
    //   return resp;
    // };

    const getPaymentSummary = async () => {
      const resp = await store.payment.getPaymentSummaryAsync.run();
      return resp;
    };
    const getSubscriptionAsync = async () => {
      const resp = await store.payment.getSubscriptionAsync.run();
      return resp;
    };
    const getUsersPaperUsageAsync = async () => {
      const resp = await store.payment.getUsersPaperUsageAsync.run();
      return resp;
    };
    const getStripeProductAsync = async () => {
      const resp = await store.payment.getStripeProductAsync.run({
        productName: 'Unit Subscription Fee'
      });
      return resp;
    };
    const getInvoices = async () => {
      const resp = await store.invoice.getInvoicesV2Async.run({
        startingAfter: null,
        endingBefore: null,
        pageSize: 15
      });
      return resp;
    };
    let promises = [
    // getAutopayMethod(),
    getPaymentMethods(), getCompanyProperties(), getCompanyUnits(),
    // getCoupons(),
    getPaymentSummary(), getSubscriptionAsync(), getUsersPaperUsageAsync(), getStripeProductAsync(), getInvoices()];
    return Promise.all([...promises]).then(resp => {
      if (resp && resp[2] && resp[2].response) {
        let result = [];
        const paymentMethods = resp[0].response;
        const companyProps = resp[1].response;
        const productName = resp[6].response;
        const invoicesResp = resp[7].response;
        paymentMethods.map(item => {
          var _obj$paymentMethod, _obj$assignedProperti;
          const exposedProperties = item.assignedPropertyIds.map(propertyId => companyProps.find(p => p.propertyId === propertyId) || undefined).filter(p => !!p);
          const stripeProductItem = productName.length ? productName[0] : '';
          const stripeProductAmount = stripeProductItem && typeof stripeProductItem.defaultAmount !== 'undefined' ? stripeProductItem.defaultAmount : '';
          const lastPaymentValue = function () {
            var _invoices$upcomingInv;
            let invoices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            let paymentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            if (!invoices.length) {
              return null;
            }
            const upcomingInvoiceId = invoices.findIndex(i => i.status.toLowerCase() === 'upcoming' && i.paymentMethodId === paymentId);
            if (upcomingInvoiceId < 0) {
              return null;
            }
            if ((_invoices$upcomingInv = invoices[upcomingInvoiceId]) !== null && _invoices$upcomingInv !== void 0 && _invoices$upcomingInv.paidAt) {
              return {
                amount: invoices[upcomingInvoiceId].amountPaid || '',
                paymentDate: invoices[upcomingInvoiceId].periodStart || ''
              };
            } else {
              return null;
            }
          };
          const nextPaymentValue = function () {
            let invoices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            let paymentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            if (!invoices.length || !paymentId) {
              return null;
            }
            const upcomingInvoiceId = invoices.findIndex(i => i.status.toLowerCase() === 'upcoming' && i.paymentMethodId === paymentId);
            if (upcomingInvoiceId < 0) {
              return null;
            }
            return {
              amount: invoices[upcomingInvoiceId].amountPaid || '',
              paymentDate: invoices[upcomingInvoiceId].periodEnd || ''
            };
          };
          const obj = {
            paymentMethod: _objectSpread({}, item),
            assignedProperties: [...exposedProperties]
          };
          obj.id = (_obj$paymentMethod = obj.paymentMethod) === null || _obj$paymentMethod === void 0 ? void 0 : _obj$paymentMethod.id;
          obj.lastPayment = lastPaymentValue(invoicesResp, obj.paymentMethod.id);
          obj.nextPayment = nextPaymentValue(invoicesResp, obj.paymentMethod.id);
          obj.pricePerUnit = stripeProductAmount;
          if ((_obj$assignedProperti = obj.assignedProperties) !== null && _obj$assignedProperti !== void 0 && _obj$assignedProperti.length) {
            result.push(obj);
          }
        });
        setCompanyProperties(result);
      }
    }).finally(() => setIsLoading(false));
  };
  const formik = useFormik({
    initialValues: couponInitialValue,
    validationSchema: couponSchema,
    onSubmit: async values => {
      const data = {
        stripeCouponId: values.coupon.trim()
      };
      await store.payment.applyCouponAsync.run(data).then(resp => {
        if (resp && resp.isSuccessful) {
          toast('success', {
            body: ['Coupon is applied']
          }); // ? i18n
          return fetchData();
        }
      });
    }
  });
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "headerTitle"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2"
  }, t('subscriptions.subscriptions'))), /*#__PURE__*/React.createElement("form", {
    onSubmit: formik.handleSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeFieldWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.codeField
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "coupon",
    label: t('subscriptions.enter_discount_code'),
    onBlur: formik.handleBlur,
    onChange: formik.handleChange,
    value: formik.values.coupon,
    variant: "outlined"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    state: "active",
    className: classes.codeButton,
    disabled: !formik.isValid || !Object.keys(formik.touched).length && !formik.values.coupon.length || store.payment.applyCouponAsync.inProgress,
    type: "submit",
    'custom-attribute': '709-payments-page-sub-tab'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "check"
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.actionButtons
  }, /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    id: "addNewProperty",
    to: "/new_property",
    size: "large",
    variant: "priority",
    'custom-attribute': '710-payments-page-sub-tab'
  }, t('subscriptions.add_property'))))), /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    className: classes.searchSection
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    variant: "outlined",
    size: "small",
    className: classes.searchSectionInput,
    value: searchKey,
    onChange: event => setSearchKey(event.target.value),
    fullWidth: true,
    placeholder: t('subscriptions.search_for_property')
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 0,
    sm: 1,
    md: 1,
    className: classes.searchSection
  }), /*#__PURE__*/React.createElement(SubscriptionSummary, {
    summaryData: {
      propertiesValue: store.company.propertiesList.length || '',
      unitsValue: store.company.companyUnitsAmount || '',
      nextPayment: store.payment.paymentSummary.total || '',
      nextPaymentDate: store.payment.paymentSummary.nextPaymentOn ? moment(store.payment.paymentSummary.nextPaymentOn).format('MM/DD/YY') : 'MM/DD/YY',
      paperInvite: store.payment.usersPaperUsage.paperInvitations.amount || '',
      paperStatement: store.payment.usersPaperUsage.paperStatements.amount || ''
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.tableWrapper
  }, isLoading && /*#__PURE__*/React.createElement(TableLoader, null), !!companyProperties.length && !!getFilteredData().length && /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    width: '380px',
    align: "left"
  }, t('subscriptions.property')), /*#__PURE__*/React.createElement(TableCell, {
    width: '290px',
    align: "left"
  }, t('subscriptions.payment_method')), /*#__PURE__*/React.createElement(TableCell, {
    width: '160px',
    align: "left"
  }, t('subscriptions.price_per_unit')), /*#__PURE__*/React.createElement(TableCell, {
    width: '150px',
    align: "left"
  }, t('subscriptions.last_payment')), /*#__PURE__*/React.createElement(TableCell, {
    width: '150px',
    align: "left"
  }, t('subscriptions.next_payment')))), /*#__PURE__*/React.createElement(TableBody, null, !!getFilteredData().length && getFilteredData().map(companyProperty => {
    var _getBank;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: companyProperty.id
    }, /*#__PURE__*/React.createElement(TableCell, {
      align: "left",
      style: {
        minWidth: '270px'
      }
    }, "".concat(companyProperty.assignedProperties.map(p => p.propertyAddress).join(', '))), /*#__PURE__*/React.createElement(TableCell, {
      align: "left",
      style: {
        minWidth: '240px'
      }
    }, !!companyProperty.paymentMethod ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
      style: {
        display: 'inline',
        verticalAlign: 'middle'
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: getBank(companyProperty.paymentMethod.brand).logo,
      width: "46",
      height: "28",
      alt: "bank logo"
    })), /*#__PURE__*/React.createElement("span", null, (_getBank = getBank(companyProperty.paymentMethod.brand)) === null || _getBank === void 0 ? void 0 : _getBank.title, "\xA0", t('subscriptions.ending_in'), " \u2022\u2022\u2022\u2022\u2006", companyProperty.paymentMethod.last4), /*#__PURE__*/React.createElement(ChangePaymentMethodModalV2, {
      selectedSubscriptionData: companyProperty,
      triggerRefresh: fetchData,
      customTrigger: /*#__PURE__*/React.createElement(IconButton, {
        size: "small",
        style: {
          paddingLeft: '5px'
        },
        'custom-attribute': '711-payments-page-sub-tab'
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "edit"
      }))
    })) : null), /*#__PURE__*/React.createElement(TableCell, {
      align: "left",
      style: {
        minWidth: '100px'
      }
    }, /*#__PURE__*/React.createElement(React.Fragment, null, renderCell(companyProperty.pricePerUnit, 'dollar'))), /*#__PURE__*/React.createElement(TableCell, {
      align: "left",
      style: {
        minWidth: '100px'
      }
    }, renderPaymentCell(companyProperty.lastPayment, 'dollar')), /*#__PURE__*/React.createElement(TableCell, {
      align: "left",
      style: {
        minWidth: '100px'
      }
    }, renderPaymentCell(companyProperty.nextPayment, 'dollar')));
  })))), !!companyProperties.length && !getFilteredData().length && /*#__PURE__*/React.createElement(NoDataPlaceholder, {
    text: "No Data Found"
  }), !companyProperties.length && /*#__PURE__*/React.createElement(NoDataPlaceholder, {
    text: "No Data Available"
  })));
});